import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import axios from "axios";
import config from "../../config/config";
import { useNavigate } from "react-router-dom";
import { CustomFormInput } from "../../Components/Common/CreatePagesComponents";
import { EmailOutlined, PasswordOutlined, Person, PhoneOutlined } from "@mui/icons-material";
import { colors } from "../../theme/theme";

const SignUp = () => {
  const navigate = useNavigate();

  const initialState = {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    gender: "",
    ip: "",
    lat: null,
    lng: null,
    country: "",
    city: "",
    state: "",
  };

  const [user, setUser] = useState(initialState);

  // -----------------------------
  // CREATE ACCOUNT
  // -----------------------------
  const createAccount = async () => {
    try {
      if (!user.email || !user.password) {
        alert("Fields are required");
        return;
      }

      if (user.password !== user.confirmPassword) {
        alert("Password Mismatched.");
        return;
      }

      const response = await axios.post(`${config.backendUrl}/user/signup`, {
        user,
      });

      console.log("User created:", response.data);

      // ---- RESET FORM COMPLETELY ----
      setUser(initialState);

      navigate("/signin");
    } catch (error) {
      alert("Signup Error: " + (error?.response?.data.message || error.message));
    }
  };

  // -----------------------------
  // AUTO FETCH IP + LOCATION
  // -----------------------------
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await axios.get("https://geolocation-db.com/json/");
        const data = res.data;

        setUser((prev) => ({
          ...prev,
          ip: data.IPv4 || "",
          country: data.country_name || "",
          city: data.city || "",
          state: data.state || "",
          lat: data.latitude || null,
          lng: data.longitude || null,
        }));
      } catch (err) {
        console.error("Error fetching IP:", err);
      }
    };

    fetchIP();
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        p: 3,
        textAlign: "center",
        bgcolor: "#fff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <img
          src={require("../../assets/images/login-handpik-logo.png")}
          alt=""
          style={{ width: "221px", height: "184px" }}
        />
      </div>

      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: "500",
          fontFamily: "Poppins",
          fontSize: "20px",
          color: colors.textColor,
          textAlign: "left",
          mt: 2,
        }}
      >
        Create your Account
      </Typography>

      <CustomFormInput
        value={user.name}
        setValue={(value) => setUser((prev) => ({ ...prev, name: value }))}
        placeholder="Name*"
        Icon={Person}
      />

      <CustomFormInput
        value={user.email}
        setValue={(value) => setUser((prev) => ({ ...prev, email: value }))}
        placeholder="Email*"
        Icon={EmailOutlined}
      />

      <CustomFormInput
        value={user.mobile}
        setValue={(value) => setUser((prev) => ({ ...prev, mobile: value }))}
        placeholder="Mobile*"
        Icon={PhoneOutlined}
      />

      <CustomFormInput
        value={user.password}
        setValue={(value) => setUser((prev) => ({ ...prev, password: value }))}
        placeholder="Password*"
        Icon={PasswordOutlined}
      />

      <CustomFormInput
        value={user.confirmPassword}
        setValue={(value) =>
          setUser((prev) => ({ ...prev, confirmPassword: value }))
        }
        placeholder="Confirm Password*"
        Icon={PasswordOutlined}
      />

      <Button
        fullWidth
        variant="contained"
        sx={{
          bgcolor: "#3C3C3C",
          color: "white",
          mt: 2,
          mb: 1,
          fontSize: "15px",
          borderRadius: "10px",
        }}
        onClick={(e) => {
          e.preventDefault();
          createAccount();
        }}
      >
        Sign Up
      </Button>

      <Typography
        variant="body2"
        sx={{ mt: 4, fontSize: "15px", color: "#3C3C3C" }}
        onClick={() => navigate("/signin")}
      >
        Already have an Account?
      </Typography>
    </Box>
  );
};

export default SignUp;
